import React from "react";
import { Card, Image, Stack, CardBody, Heading, Text, CardFooter, Button, Link, Box, Grid, Center } from "@chakra-ui/react";
import GitHubCalendar from 'react-github-calendar';

const Projects = () => {
  return (
    <Center >
    <Stack id="projects">
      <Box marginBottom="5%" ml={-5}>
        <Text fontSize="45px" marginLeft="30px" marginRight="30px" textAlign="center" color="#cd5ff8">
          Projects
        </Text>
      </Box>
      <Card
        direction={{ base: 'column', sm: 'row' }}
        overflow='hidden'
        variant='outline'
        className="project-card"
        marginBottom="20px" // Add gap between each card
        w={"80%"}
        m={"auto"}
      >
        <Image
          objectFit='cover'
          maxW={{ base: '100%', sm: '200px' }}
          src='https://i.imgur.com/snp04XN.png'
          alt='Caffe Latte'
        />

        <Stack>
          <CardBody>
            <Heading class="project-title" size='md'>Mbalayang</Heading>

            <Text className="project-description" py='2' textAlign={"left"} ml={"3%"}>
              The objective of this project is to create a travel website called "Mbalayang" using React and a REST API. Mbalayang will provide users with information about various travel destinations, allow them to search for flights and accommodations, and book their travel arrangements.
            </Text>
            <Text className="project-tech-stack" py='2'>
            <Heading size={"md"} textAlign={"left"} ml={"3%"}>Tech Stack:</Heading>
            <ul style={{textAlign:"left", marginLeft:"3%"}}>
              <li>HTML, CSS, JavaScript: Building blocks of web development.</li>
              <li>React: JavaScript library for building user interfaces.</li>
              <li>Redux: State management for consistent data handling.</li>
              <li>Chakra UI: Component library for creating modern UIs.</li>
              <li>JSON Server: Simulated backend for handling hotel data.</li>
              <li>React Router: Handling client-side routing.</li>
              <li>Vercel: Deployment platform for web applications.</li>
            </ul>
            </Text>
          </CardBody>

          <CardFooter>
            <Button className="project-github-link" variant='solid' colorScheme='blue' mr={2}>
              <a href="https://github.com/NITINPANDIT1/mbalayang">Github</a>
            </Button>
            <Button className="project-deployed-link" variant='solid' colorScheme='blue'>
              <a href="https://mbalayang.vercel.app/">Deployed link</a>
            </Button>
          </CardFooter>
        </Stack>
      </Card>
      <Card
        direction={{ base: 'column', sm: 'row' }}
        overflow='hidden'
        variant='outline'
        className="project-card"
        marginBottom="20px" // Add gap between each card
        w={"80%"}
        m={"auto"}
      >
        <Image
          objectFit='cover'
          maxW={{ base: '100%', sm: '200px' }}
          src='https://i.imgur.com/0sOecAZ.png'
          alt='Caffe Latte'
        />

        <Stack>
          <CardBody>
            <Heading class="project-title" size='md'>Green Paradise</Heading>

            <Text className="project-description" py='2' textAlign={"left"} ml={"3%"}>
              The objective of this project is to create an e-commerce website called "Green Paradise" using React and a REST API. Green Paradise will provide users with information about various plants and gardening products.
            </Text>
            <Text className="project-tech-stack" py='2'>
            <Heading size={"md"} textAlign={"left"} ml={"3%"}>Tech Stack:</Heading>
            <ul style={{textAlign:"left", marginLeft:"3%"}}>
              <li>HTML, CSS, JavaScript: Building blocks of web development.</li>
              <li>React: JavaScript library for building user interfaces.</li>
              <li>Redux: State management for consistent data handling.</li>
              <li>Chakra UI: Component library for creating modern UIs.</li>
              <li>JSON Server: Simulated backend for handling hotel data.</li>
              <li>React Router: Handling client-side routing.</li>
              <li>Vercel: Deployment platform for web applications.</li>
            </ul>
            </Text>
          </CardBody>

          <CardFooter>
            <Button className="project-github-link" variant='solid' colorScheme='blue' mr={2}>
              <a href="https://github.com/NITINPANDIT1/Ecommerce-Web-App---Green-Paradise">Github</a>
            </Button>
            <Button className="project-deployed-link" variant='solid' colorScheme='blue'>
              <a href="https://fluffy-cocada-764c66.netlify.app/">Deployed link</a>
            </Button>
          </CardFooter>
        </Stack>
      </Card>
      <Card
        direction={{ base: 'column', sm: 'row' }}
        overflow='hidden'
        variant='outline'
        className="project-card"
        marginBottom="20px" // Add gap between each card
        w={"80%"}
        m={"auto"}
      >
        <Image
          objectFit='cover'
          maxW={{ base: '100%', sm: '200px' }}
          src='https://i.imgur.com/aNzO9MT.png'
          alt='EddieBuer'
        />

        <Stack>
          <CardBody>
            <Heading class="project-title" size='md'>EddieBuer</Heading>

            <Text className="project-description" py='2' textAlign={"left"} ml={"3%"}>
              The objective of this project is to create a clone of the Eddie Bauer website using HTML, CSS, and JavaScript. The clone should replicate the overall layout, design, and functionality of the original Eddie Bauer website, allowing users to browse and purchase products, view their shopping cart, and proceed to checkout.
            </Text>
            <Text textAlign={"left"} ml={"3%"} className="project-tech-stack" py='2'>
            Use HTML to structure the web pages, CSS for styling and layout, and JavaScript for interactivity and dynamic functionality.
            Utilize CSS frameworks like Bootstrap or Tailwind CSS to expedite the development process and ensure a consistent design.
            Implement JavaScript libraries, such as jQuery or React, to simplify DOM manipulation and enhance user interactions.
            Make use of local storage or cookies to store user information temporarily during the shopping session.
            Employ AJAX or Fetch API to handle asynchronous requests, such as adding items to the cart or updating the cart total.
            <Heading size={"md"} textAlign={"left"} mt={"3%"}>Tech Stack:</Heading>
            <ul style={{textAlign:"left"}}>
              <li>HTML, CSS, JavaScript: Building blocks of web development.</li>
              <li>JSON Server: Simulated backend for handling hotel data.</li>
              <li>Vercel: Deployment platform for web applications.</li>
            </ul>
            </Text>
          </CardBody>

          <CardFooter>
            <Button className="project-github-link" variant='solid' colorScheme='blue' mr={2}>
              <a href="https://github.com/monurajputrko/EddieBuer-U4-" >Github</a>
            </Button>
            <Button className="project-deployed-link" variant='solid' colorScheme='blue'>
              <a href="https://zingy-flan-b0d67e.netlify.app/">Deployed link</a>
            </Button>
          </CardFooter>
        </Stack>
      </Card>
      <Card
        direction={{ base: 'column', sm: 'row' }}
        overflow='hidden'
        variant='outline'
        className="project-card"
        marginBottom="20px" // Add gap between each card
        w={"80%"}
        m={"auto"}
      >
        <Image
          objectFit='cover'
          maxW={{ base: '100%', sm: '200px' }}
          src='https://i.imgur.com/S7KWNlb.png'
          alt='Caffe Latte'
        />

        <Stack>
          <CardBody>
            <Heading class="project-title" size='md'>Bhojanalaya</Heading>

            <Text className="project-description" py='2' textAlign={"left"} ml={"3%"}>
              The objective of this project is to create catering website called "Bhojanalaya" using React and a REST API.
            </Text>
            <Text className="project-tech-stack" py='2' textAlign={"left"} ml={"3%"}>
            Create the user interface and facilitate component-based development using React.js.
            Manage various pages and navigation in your application with React Router.
            Send HTTP requests to the REST API and process responses using either Axios or the Fetch API.
            Manage the application's state and data flow by employing state management libraries like Redux or React Context.
            Style your components and maintain a cohesive design using modern CSS techniques such as CSS modules, CSS-in-JS, or a CSS preprocessor like Sass.
            Incorporate form validation and error messaging using libraries like Formik or React Hook Form.
            Enable authentication using JSON Web Tokens (JWT) or other authentication mechanisms provided by the REST API.
            
            <Heading size={"md"} textAlign={"left"} mt={"3%"}>Tech Stack:</Heading>
            <ul style={{textAlign:"left"}}>
              <li>HTML, CSS, JavaScript: Building blocks of web development.</li>
              <li>React: JavaScript library for building user interfaces.</li>
              <li>React Router: Handling client-side routing.</li>
              <li>JSON Server: Simulated backend for handling hotel data.</li>
              <li>Vercel: Deployment platform for web applications.</li>
            </ul>
            </Text>
          </CardBody>

          <CardFooter>
            <Button className="project-github-link" variant='solid' colorScheme='blue' mr={2}>
              <a href="https://github.com/Kamalakanta01/Bhojanalaya">Github</a>
            </Button>
            <Button className="project-deployed-link" variant='solid' colorScheme='blue'>
              <a href="https://bhojanalaya.onrender.com/">Deployed link</a>
            </Button>
          </CardFooter>
        </Stack>
      </Card>

      <Box m={"auto"}>
        <Box gap={6}>
          <Center mb={"3%"} mt={"3%"}>
            <Link href="https://github.com/Kamalakanta01">
              <Image id="github-streak-stats" src="https://github-readme-streak-stats.herokuapp.com/?user=Kamalakanta01&theme=radical&hide_border=true&stroke=0000&background=#122722"/>
            </Link>
          </Center>
          <Center mb={"3%"}>
            <Image src="https://github-profile-summary-cards.vercel.app/api/cards/profile-details?username=Kamalakanta01&theme=2077"/>
          </Center>
        </Box>
        <Grid gridTemplateColumns={["1fr", "repeat(2, 1fr)"]} justifyContent={"space-around"} mb={"3%"}>
          <Center>
            <Image id="github-top-langs" src="https://github-readme-stats.vercel.app/api/top-langs?username=Kamalakanta01&theme=2077" />
          </Center>
          <Center>
            <Image src="https://github-profile-summary-cards.vercel.app/api/cards/most-commit-language?username=Kamalakanta01&theme=2077"/>
          </Center>
        </Grid>
        <Grid gridTemplateColumns={["1fr", "repeat(2, 1fr)"]} justifyContent={"space-around"} mb={"3%"}>
          <Center>
            <Image id="github-stats-card" src="https://github-readme-stats.vercel.app/api?username=Kamalakanta01&theme=2077" />
          </Center>
          <Center>
            <Image src="https://github-profile-summary-cards.vercel.app/api/cards/productive-time?username=Kamalakanta01&theme=2077&utcOffset=8"/>
          </Center>
        </Grid>
        <Box>
          <Center ml={[0,-12]}>
            <GitHubCalendar username= "Kamalakanta01" />
          </Center>
        </Box>
      </Box>
    </Stack>
    </Center>
  );
};

export default Projects;